// extracted by mini-css-extract-plugin
module.exports = {"container":"universal-image_container__4ty9u","circularImage":"universal-image_circularImage__mzWJA"};